<template>
  <div class="spotAdd">
    <LoadingPlaceholder v-if="loading" />
    <form v-else>
      <div class="form-group">
        <h4 class="m-0 mt-3">
          {{ "Photopoint" }}
        </h4>
        <hr class="m-0 mb-3" />
        <label>{{ $t("locaion") }}</label>
        <select
          v-model="spot.locationId"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('Type') },
          ]"
        >
          <optgroup
            v-for="group in locationGroups"
            :key="`loc-group-${group.resortId}`"
            :label="group.label"
          >
            <option
              v-for="loc in group.locations"
              :key="`loc-spot-${loc.id}`"
              :value="loc.id"
            >
              {{ `Location ${loc.id}` }}
            </option>
          </optgroup>
        </select>
        <hr class="m-0 mb-3" />
        <label>Spot type</label>
        <select
          v-model="spot.typeId"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('Type') },
          ]"
        >
          <option
            v-for="(pointType, index) in pointTypes"
            :key="`pointType-spot-${index}`"
            :value="pointType.id"
          >
            {{ `${pointType.id} - ${pointType.name}` }}
          </option>
        </select>
        <hr class="m-0 mb-3" />
        <label>Spot subtype</label>
        <select
          v-model="spot.attributes.type"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('Type') },
          ]"
        >
          <option
            v-for="(spotType, index) in spotTypes"
            :key="`spotType-spot-${index}`"
            :value="spotType"
          >
            {{ `${spotType}` }}
          </option>
        </select>
        <hr class="m-0 mb-3" />
        <label>{{ $t("resortSpotAndPhotopoint.displayName") }}</label>
        <input
          v-model="spot.name"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('DisplayName') },
          ]"
          type="text"
        />
        <div class="m-0 mb-3" />
        <label>{{ $t("b2b_statistics") }}</label>
        <input
          v-model="spot.attributes.b2b_statistics"
          type="checkbox"
          class="ml-3"
        />
        <div class="m-0 mb-3" />
        <label>{{ $t("has_timing") }}</label>
        <input
          v-model="spot.attributes.has_timing"
          type="checkbox"
          class="ml-3"
        />
        <div class="m-0 mb-3" />
        <label>{{ $t("sponsored") }}</label>
        <input
          v-model="spot.attributes.sponsored"
          type="checkbox"
          class="ml-3"
        />
        <div class="m-0 mb-3" />
        <label>{{ $t("visible") }}</label>
        <input
          v-model="spot.visible"
          type="checkbox"
          class="ml-3"
        />
        <div class="m-0 mb-3" />
        <label>{{ $t("active") }}</label>
        <input
          v-model="spot.active"
          type="checkbox"
          class="ml-3"
        />
      </div>
      <LoadingPlaceholder v-if="upsertLoading" />
      <button
        v-else
        class="btn btn-primary float-right"
        style="background-color: #e6007e; border-color: #e6007e;"
        @click.prevent="editSpot()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="check"
        />{{ $t("add") }}
      </button>
      <div class="clearfix" />
    </form>
  </div>
</template>

<script>
import { errorMixin } from '@/mixins/errorMixin.js';

export default {
  name: "SpotEdit",
  mixins: [
    errorMixin
  ],
  props: {
    resortId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      pointTypes: [],
      locations: [],
      upsertLoading: false,
      loading: true,
      spot: {
        externalIds: [],
        attributes: {
        },
      },
    }
  },
  computed: {
    locationGroups () {
      const groups = {};
      (this.locations || []).forEach((loc) => {
        const resortId = loc.resortId || this.resortId;
        if (!groups[resortId]) {
          groups[resortId] = [];
        }
        groups[resortId].push(loc);
      });
      return Object.keys(groups)
        .map((id) => ({
          resortId: Number(id),
          label: `Resort ${id}`,
          locations: groups[id],
        }))
        .sort((a, b) => a.resortId - b.resortId);
    },
    spotTypes () {
      return ['Carving', 'Cross', 'Downhill', 'Flight', 'Freeride', 'GiantSlalom', 'GlacierExperience', 'MixRace', 'Moguls', 'Photostart', 'Race', 'Slalom', 'Sledding', 'Speed', 'WinterHiking'];
    },
  },
  created() {
    this.getPointTypes()
    this.getLocations()
  },
  methods: {
    getPointTypes () { 
      this.loading = true;
      this.axios.get(`/Resort/GetPointTypes`)
      .then(response => {
        this.pointTypes = response.data;
      })
      .finally(() => {
        this.loading = false;
      });
    },
    getLocations () { 
      this.axios.get(`/Resort/GetResortLocations?resortId=${this.resortId}&includeSharedResorts=true`)
      .then(response => {
        this.locations = response.data;
      });
    },
    async editSpot () {
      this.upsertLoading = true
      this.spot.externalIds = (this.spot.externalIds || []).filter(
        (x) => x && x.length > 0
      );
      this.spot.resortId = this.resortId
      await this.axios.post('/Resort/CreateSpotForResort', this.spot)
        .then(() => {
          this.$snotify.success(this.$t('resortSpotAndPhotopoint.addedSuccessfullySpot'));
          this.$emit("reload");
          this.error_clear();
          this.upsertLoading = false
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    }
  }
}
</script>

<style scoped>
.spotAdd .progress {
  display: flex;
  flex: 1 1 auto;
  width: 1%;
  height: 20px;
  font-size: 1rem;
}
</style>
